import { Grid, Box, Typography, Theme } from '@quillbot/design-system';
import { makeStyles } from '@mui/styles';
import withTheme from '@mui/styles/withTheme';
import css from 'assets/scss/tryHomePremium.module.scss';
import React from 'react';
import 'lazysizes';
// import a plugin
import 'lazysizes/plugins/parent-fit/ls.parent-fit';
// import Track from 'core/logger/track';
import { CHAR_LIMITS } from 'config/constants';
import { numberFormatter } from 'core/utils';

const TryHomeGetPremium = ({ theme }: { theme: Theme }) => (
  <Grid container>
    <div className={`${css.premiumHolder} ${css.container} `}>
      <img
        style={{ paddingLeft: '15px' }}
        src="./images/theme/commonImages/homePagePremiumLabelNew.svg"
        alt="Premium Label"
      />

      <div className={`${css.container} ${css.premiumFeaturetitle} `}>
        <Grid item container lg={12} sm={12} xs={12}>
          <h2 className={css.sectionTitle}>
            Cut your writing time by more than half <br />
            using QuillBot Premium
          </h2>
        </Grid>

        <Grid container className={`${css.premiumFeatureBox}`}>
          <Box className={`${css.premiumFeatureBoxInner}`}>
            <div className={`${css.premiumBox}`}>
              <Typography variant="caption" component="span" color="primary">
                ACCELERATE
              </Typography>
              <div>
                <img
                  key={theme.palette.mode}
                  data-src={`/images/theme/${theme.palette.mode}/commonImages/newWords.svg`}
                  alt="Accelerate"
                  className="lazyload"
                />
              </div>
              <h3>Improve your speed</h3>
              <p>
                Paraphrase an unlimited number of words in one click, with a faster processing rate
                to get more done in less time.
              </p>
            </div>
          </Box>

          <Box className={` ${css.premiumFeatureBoxInner} `}>
            <div className={`${css.premiumBox}  `}>
              <Typography variant="caption" component="span" color="primary">
                CREATE
              </Typography>
              <div>
                <img
                  key={theme.palette.mode}
                  data-src={`/images/theme/${theme.palette.mode}/commonImages/newCreate.svg`}
                  alt="Integrate"
                  className="lazyload"
                />
              </div>
              <h3>Increase Changes</h3>
              <p>Unlock the final Synonyms setting to maximize the changes to your text.</p>
            </div>
          </Box>

          <Box className={`${css.premiumFeatureBoxInner} `}>
            <div className={`${css.premiumBox} ${css.last} `}>
              <Typography variant="caption" component="span" color="primary">
                Deliver a clear message
              </Typography>
              <div>
                <img
                  key={theme.palette.mode}
                  data-src={`/images/theme/${theme.palette.mode}/commonImages/allModesNew.svg`}
                  alt="Customize"
                  className="lazyload"
                />
              </div>
              <h3>Improve Meaning</h3>
              <p>Unlock five more modes to give yourself even more flexibility in your writing.</p>
            </div>
          </Box>
        </Grid>

        {/* <Grid container>
            <Grid
              item
              lg={12}
              md={12}
              xs={12}
              className={classes.premiumButtonBox}
              style={{ textAlign: 'center', marginTop: '50px' }}>
              <a
                className={`${css.yellowBtn} ${css.dimondIconBtn}`}
                target="_blank"
                rel="noopener noreferrer"
                href={`/premium${props.referrer ? `?referrer=${props.referrer}` : ''}`}
                onClick={() => Track.getInstance().premiumLinkClicked(props.referrer || '')}>
                <img
                  src="./images/landinPage/dimondIconBtn.svg"
                  className={css.dimondIcon}
                  alt="diamond icon"
                />{' '}
                Get Premium
              </a>
              <p style={{ fontSize: '16px' }}>
                <i>3 Day Money-Back Guarantee</i>
              </p>
            </Grid>
          </Grid> */}
      </div>
    </div>
  </Grid>
);

export default withTheme<Theme, React.FunctionComponent<{ theme: Theme }>>(TryHomeGetPremium);
